import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, createStyles, withStyles } from '@material-ui/core';
import green from '@material-ui/core/colors/green';
import dayjs from 'dayjs';
import { I18n } from 'src/translations/i18n';
import { loadUserCurrentActivity } from 'src/store/actions/calendarActions';
import { selectCurrentActivityByUserId } from 'src/store/selectors/calendar';
import { selectLocale } from 'src/store/selectors/translationSelectors';
import WorkShiftManagementFormInDialog from '../WorkShiftManagementForm/WrappedIntoDialog';
const styles = () => createStyles({
    button: {
        minWidth: 44,
        height: 32,
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        color: 'white',
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[600]
        }
    }
});
function WorkShiftButton({ classes, userId, miniLabel }) {
    const [dialogOpen, setDialogOpen] = useState(false);
    const getCurrentActivity = useSelector(selectCurrentActivityByUserId);
    const locale = useSelector(selectLocale);
    const dispatch = useDispatch();
    useEffect(() => {
        if (userId) {
            dispatch(loadUserCurrentActivity(userId));
        }
    }, [dispatch, userId]);
    const currentActivity = useMemo(() => {
        if (userId) {
            return getCurrentActivity(userId);
        }
        return null;
    }, [getCurrentActivity, userId]);
    const buttonLabel = useMemo(() => {
        if (miniLabel) {
            return '⏵';
        }
        else if (currentActivity) {
            const timeStarted = currentActivity.Event?.StartTime && dayjs(currentActivity.Event.StartTime).format('HH:mm');
            return timeStarted ? `${I18n.t('Started')}: ${timeStarted}` : I18n.t('Started');
        }
        else {
            return I18n.t('StartShift');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentActivity, locale, miniLabel]);
    const toggleDialogOpen = useCallback(() => {
        setDialogOpen((oldValue) => !oldValue);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "contained", size: "small", onClick: toggleDialogOpen, className: [classes.button, 'line-clamp-ellipsis'].join(' ') }, buttonLabel),
        React.createElement(WorkShiftManagementFormInDialog, { isOpen: dialogOpen, onClose: toggleDialogOpen, userId: userId })));
}
export default withStyles(styles)(WorkShiftButton);
